// Effects may own a function or nested groups of functions. Ignore unrelated
// return values and finish releasing a group even if one member fails.
export function ownedCleanup(value: unknown, onError = (error: unknown) => console.debug('Cleanup failed', error instanceof Error ? error.message : String(error))) {
    if (typeof value !== 'function' && !Array.isArray(value)) return undefined
    let released = false
    return () => {
        if (released) return
        released = true
        const run = (item: unknown) => {
            if (Array.isArray(item)) item.slice().forEach(run)
            else if (typeof item === 'function') { try { item() } catch (error) { onError(error) } }
        }
        run(value)
        value = undefined
    }
}
